import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useSite } from '@/entities/site/model/queries'
import { useClient } from '@/entities/client/model/queries'
import { SiteDetail } from '@/features/client-profile/sections/client-sites/SiteDetail'
import { Skeleton } from '@/shared/components/ui/skeleton'
import { Button } from '@/shared/components/ui/button'

export const Route = createFileRoute('/clients/$clientId/sites/$siteId/')({
  component: SiteDetailPage,
  staticData: { authorize: true },
})

function SiteDetailPage() {
  const router = useRouter()
  const { clientId, siteId } = Route.useParams()
  const clientIdNum = parseInt(clientId)
  const siteIdNum = parseInt(siteId)

  const { data: client } = useClient(clientIdNum)
  const { data: site, isLoading: isLoadingSite } = useSite(siteIdNum)

  const handleBack = () => {
    router.history.back()
  }

  if (isLoadingSite) {
    return (
      <div className="space-y-6 p-6">
        <Skeleton className="h-10 w-48" />
        <Skeleton className="h-[600px] w-full" />
      </div>
    )
  }

  if (!site) {
    return (
      <div className="flex flex-col items-center justify-center p-12">
        <p className="text-lg font-medium">Site not found</p>
        <p className="text-sm text-muted-foreground">
          The site you're looking for doesn't exist.
        </p>
        <Button className="mt-4" onClick={handleBack}>
          Go Back
        </Button>
      </div>
    )
  }

  return (
    <SiteDetail
      site={site}
      clientName={client?.name}
      onBack={handleBack}
    />
  )
}
